<template>
  <div class="not-found flex-column align-center">
    <svg class="illustration" width="220" height="200" viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="30" y="20" width="160" height="150" rx="8" fill="#0A3D2E"/>
      <rect x="40" y="30" width="68" height="130" rx="4" fill="#2F6E5A"/>
      <rect x="112" y="30" width="68" height="130" rx="4" fill="#FBFFD6"/>
      <path d="M112 30 L150 44 V146 L112 160 Z" fill="#1ABC6C" opacity=".35"/>
      <circle cx="98" cy="95" r="4" fill="#FAFAFA"/>
      <circle cx="122" cy="95" r="4" fill="#0A3D2E"/>
      <rect x="44" y="170" width="12" height="14" fill="#3F3F46"/>
      <rect x="164" y="170" width="12" height="14" fill="#3F3F46"/>
    </svg>
    <div class="code title-1">404</div>
    <h1 class="title-3">Página não encontrada</h1>
    <p class="subtitle-6">
      O endereço que você tentou acessar não existe ou foi movido.
    </p>
    <router-link :to="{ name: 'Home' }">
      <button class="btn-primary">Voltar para o início</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
.not-found {
  min-height: 60vh;
  padding: 120px 20px 40px;
  text-align: center;
  color: #0A3D2E;
  .illustration {
    max-width: 100%;
    height: auto;
  }
  .code {
    margin-top: 16px;
    font-size: 72px;
    line-height: 80px;
    color: #1ABC6C;
  }
  p {
    margin: 12px 0 28px;
    max-width: 420px;
    color: #3F3F46;
  }
}
</style>